import { getActiveEnv, toggleEnvironment } from '@/services/baseUrlService';

/**
 * A sleek toggle button that switches between Production and Development APIs.
 * Shows the current environment with a color-coded pill and allows instant switching.
 */
function EnvToggle() {
  const activeEnv = getActiveEnv();
  const isDev = activeEnv === 'development';

  return (
    <button
      onClick={toggleEnvironment}
      title={`Switch to ${isDev ? 'Production' : 'Development'} API`}
      className="group relative flex items-center gap-2 rounded-lg border px-2.5 py-1.5 text-xs font-medium transition-all duration-200 hover:shadow-sm"
      style={{
        borderColor: isDev ? '#f59e0b40' : '#22c55e40',
        backgroundColor: isDev ? '#fef3c710' : '#f0fdf410',
      }}
    >
      {/* Status dot */}
      <span
        className="relative flex h-2 w-2"
      >
        <span
          className="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
          style={{ backgroundColor: isDev ? '#f59e0b' : '#22c55e' }}
        />
        <span
          className="relative inline-flex h-2 w-2 rounded-full"
          style={{ backgroundColor: isDev ? '#f59e0b' : '#22c55e' }}
        />
      </span>

      {/* Label */}
      <span
        className="hidden sm:inline"
        style={{ color: isDev ? '#d97706' : '#16a34a' }}
      >
        {isDev ? 'DEV' : 'PROD'}
      </span>

      {/* Hover tooltip */}
      <span className="pointer-events-none absolute -bottom-8 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-coal-800 px-2 py-1 text-[10px] text-white opacity-0 shadow-lg transition-opacity group-hover:opacity-100">
        Click to switch to {isDev ? 'Production' : 'Dev'}
      </span>
    </button>
  );
}

export default EnvToggle;
